
<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">

        <!-- <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3">

        <div class="text-start mb-3">
            <span class="fw-bold" style="font-size: 20px;">Counter Name: <strong class="text-success">M23</strong></span>
        </div> -->

        <div class="text-end mb-3">
            <button v-if="counter_details.counter_availability == 1" @click="changeAvailability(2)" type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#tokensModal">
                Make Unavailable
            </button>
            <button v-else type="button" @click="changeAvailability(1)" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#tokensModal">
                Make Available
            </button>
            <button type="button" @click="logout()" class="btn btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#tokensModal">
                Logout
            </button>
        </div>
        <!-- </div> -->

        <!-- Current Token Card -->
        <div class="card shadow-sm mb-4">
          <div class="card-body">
            <h5 class="text-center m-4 fw-bold text-secondary" style="font-size: 30px;">{{ counter_details.counter_name }}</h5>

            <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3 m-4">
                <div class="text-center text-sm-start">
                    <span class="fw-bold" style="font-size: 30px;">Current Token: <strong class="text-success">{{ token_details.token }}</strong></span>
                    <!-- <span class="fw-bold" v-if="token_details.token">Patient Name: {{ token_details.patient_name }}</span>                                 -->
                    <div v-if="token_details.token" class="mt-2">
                        <span class="fw-bold">Booking Date: {{ token_details.booking_date | formatDate }}</span>
                    </div>
                </div>
                <div v-if="counter_details.counter_availability == 1" class="d-flex flex-column flex-sm-row gap-2 mt-3 mt-sm-0">
                  <button class="btn btn-warning btn-lg" v-if="token_details.token" @click="noShowToken()">
                      No Show
                  </button>
                  <button class="btn btn-danger btn-lg" v-if="token_details.token" @click="recallToken()">
                      Recall
                  </button>
                  <button class="btn btn-success btn-lg" @click="callNextToken()" :disabled="callingNextToken">
                      <span v-if="callingNextToken" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      <span v-if="callingNextToken">Calling...</span>
                      <span v-else>Call Next Token</span>
                  </button>
                </div>
            </div>
          </div>
        </div>

        <!-- Token List Table Card -->
        <!-- <div class="card shadow-sm">
          <div class="card-body">
            <h5 class="text-center mb-4 fw-bold text-primary">Tokens</h5>

            <div class="table-responsive">
              <table class="table table-bordered align-middle mb-0">
                <thead style="background-color: #007bff; color: white;">
                  <tr class="text-center">
                    <th width="40%">Token</th>
                    <th width="60%">Customer</th>
                  </tr>
                </thead>
                <tbody class="table-light">
                  <tr class="text-center fw-semibold">
                    <td>
                      <span class="badge bg-warning fs-6 px-3 py-2">M23</span>
                    </td>
                    <td>Anwar</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div> -->

        <!-- No Show Token List Table Card -->
        <div class="card shadow-sm">
           <!--<div class="card-body">
            <h5 class="text-center fw-bold" style="font-size: large;">Remaining Tokens Count: <strong class="text-success">{{ remaining_token_count }}</strong></h5>
          </div>-->
          <div class="card-body">
            <div class="row">
                    <div class="col-6 text-start mb-3">
            <h5 class="text-center fw-bold" style="font-size: large;">Remaining Tokens Count: <strong class="text-success">{{ remaining_token_count }}</strong></h5>
                    </div>
                    <div class="col-6 text-end mb-3">
            <h5 class="text-center fw-bold" style="font-size: large;">No Show Tokens Count: <strong class="text-success">{{ noshow_token_count }}</strong></h5>
                    </div>
                </div>
          </div>

        </div>

        <!-- No Show Tokens List Card -->
        <div class="card shadow-sm mb-4">
          <div class="card-body" v-if="counter_details.counter_availability == 1">
            <h5 class="text-center mb-4 fw-bold text-danger">No Show Tokens</h5>
            
            <div v-if="noshow_tokens && noshow_tokens.length > 0" class="table-responsive">
              <table class="table table-bordered align-middle mb-0">
                <thead style="background-color: #dc3545; color: white;">
                  <tr class="text-center">
                    <th width="25%">Token</th>
                    <th width="25%">Booking Date</th>
                    <th width="15%">Actions</th>
                  </tr>
                </thead>
                <tbody class="table-light">
                  <tr v-for="token in noshow_tokens" :key="token.booking_id" class="text-center fw-semibold">
                    <td>
                      <span class="badge bg-danger fs-6 px-3 py-2">{{ token.token }}</span>
                    </td>
                    <td>{{ token.booking_date | formatDate }}</td>
                    <td>
                      <button class="btn btn-sm btn-outline-primary" @click="recallNoShowToken(token)">
                        Recall
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div v-else class="text-center text-muted py-4">
              <i class="fas fa-inbox fa-3x mb-3"></i>
              <p class="mb-0">No no-show tokens found</p>
            </div>
          </div>
        </div>

        <!-- <div class="card shadow-sm mb-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-6 text-start mb-3">
                        <span class="fw-bold">Remaining Tokens: <strong class="text-danger">22</strong></span>
                    </div>
                    <div class="col-6 text-end mb-3">
                        <span class="fw-bold">No Show Tokens: <strong class="text-danger">1</strong></span>
                    </div>
                </div>
            </div>
        </div> -->
      </div>
    </div>
  </div>
</template>


<script>


export default {
  // ... other options
  data() {
    return {
      counter_available: 1,
      errors: {},
      token: '',
      counter_details: {},
      token_details: {
        booking_id: "",
        patient_name: "",
        booking_date: "",
        token: "",
        counter_id: "",
        updated_at: ""
      },
      remaining_token_count: 0,
      noshow_token_count: 0,
      noshow_tokens: [],
      refreshInterval: null, // Add this
      callingNextToken: false,
    };
  },

  mounted() {
    this.redirectIfOutsourceCounter();
    this.fetchToken();
    this.startAutoRefresh();
  },

  beforeDestroy() {
    this.stopAutoRefresh(); // Add this
  },

  methods: {

    redirectIfOutsourceCounter() {
      try {
        const stored = JSON.parse(localStorage.getItem('medicino_counter') || 'null');
        if (stored && Number(stored.token_management_type) === 3) {
          this.$router.replace({ name: 'outsource-tokens' });
        }
      } catch (e) {
        /* ignore */
      }
    },

    redirectToLoginForTokenTypeChange() {
      this.stopAutoRefresh();
      localStorage.removeItem('medicino_counter');
      this.$swal('', 'Token management type was updated. Please login again.', 'warning');
      this.$router.replace({ name: 'login' });
    },

    handleTokenTypeMismatchError(error) {
      if (error?.response?.status === 403) {
        this.redirectToLoginForTokenTypeChange();
        return true;
      }
      return false;
    },

    getToken() {
        if (localStorage.getItem('medicino_counter')) {
            var medicino_counter = JSON.parse(localStorage.getItem('medicino_counter'));
            if (medicino_counter.token) {
                this.token = medicino_counter.token;
                this.user = medicino_counter;
                console.log(this.user);
            } else {
                this.$swal("", "Failed to fetch token, please login again", "error");
                this.$router.push({ name: "login" });
            }

        } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
        }
    },
    startAutoRefresh() {
      // Refresh every 10 seconds
      this.refreshInterval = setInterval(() => {
        this.fetchRemainingTokenCount();
      }, 20000);
    },

    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },

    fetchRemainingTokenCount() {  
        let url = "counter/remaining-tokens";         
        this.getToken();
        this.$axios
          .get(url, { headers: { Authorization: "Bearer " + this.token } })
          .then((res) => {
            var responseData = res.data.data;
            console.log(responseData);
            this.remaining_token_count = responseData.remaining_token_count;
            this.noshow_token_count = responseData.noshow_count;
          })
          .catch((err) => {
            if (!this.handleTokenTypeMismatchError(err)) console.log(err);
          });
    },

    fetchToken() {  
      this.clearToken();
      let url = "counter/tokens";         
      this.getToken();
      this.$axios
          .get(url, { headers: { Authorization: "Bearer " + this.token } })
          .then((res) => {
            var responseData = res.data.data;
            console.log(responseData);
            if (
              responseData?.token_management_type != null &&
              Number(responseData.token_management_type) === 3
            ) {
              this.redirectToLoginForTokenTypeChange();
              return;
            }
            if (
              responseData?.counter_details?.token_management_type != null &&
              Number(responseData.counter_details.token_management_type) === 3
            ) {
              this.redirectToLoginForTokenTypeChange();
              return;
            }
            this.counter_details = responseData.counter_details;
            this.remaining_token_count = responseData.remaining_token_count;
            this.noshow_token_count = responseData.noshow_count;
            this.token_details.booking_id = responseData?.token_details?.booking_id;
            this.token_details.token = responseData?.token_details?.token;
            this.token_details.counter_id = responseData?.token_details?.counter_id;
            this.token_details.updated_at = responseData?.token_details?.updated_at;
            this.token_details.booking_date = responseData?.token_details?.booking_date;
            this.token_details.patient_name = responseData?.token_details?.name;
            this.noshow_tokens = responseData.noshow_tokens || [];            

          })
          .catch((err) => {
            if (!this.handleTokenTypeMismatchError(err)) console.log(err);
          });
    },

    recallToken() {  

      this.getToken();

      const config = {
          headers: {
            "Accept": "application/json",
            "Authorization": "Bearer " + this.token,
          },
      };

      let url = "counter/recallToken";        
      
      let formData = new FormData();
      formData.append("booking_id", this.token_details.booking_id);
      formData.append("token", this.token_details.token); 

      this.$axios
        .post(url, formData, config)
        .then((res) => {
          var responseData = res.data.message;
          console.log(responseData);
          this.$swal("", responseData, "success");
        })
      .catch((error) => {
        if (error.response) {
            if (error.response.data.message) {
              this.$swal("", error.response.data.message, "error");
              this.fetchToken();
            } else {
              this.$swal("", "Something went wrong", "error");
            }
        } else {
            this.$swal("", "Something went wrong", "error");
        }
      })
               .finally(() => (this.loading = false));
     },

     recallNoShowToken(token) {
       this.getToken();
       
       const config = {
         headers: {
           "Accept": "application/json",
           "Authorization": "Bearer " + this.token,
         },
       };
       
       let url = "counter/recallNoShowToken";
       
       let formData = new FormData();
       formData.append("booking_id", token.id);
       formData.append("token", token.token);
       
       this.$axios
         .post(url, formData, config)
         .then((res) => {
           var responseData = res.data.message;
           console.log(responseData);
           this.$swal("", responseData, "success");
           this.fetchToken(); // Refresh the data
         })
         .catch((error) => {
           if (error.response) {
             if (error.response.data.message) {
               this.$swal("", error.response.data.message, "error");
             } else {
               this.$swal("", "Something went wrong", "error");
             }
           } else {
             this.$swal("", "Something went wrong", "error");
           }
         })
         .finally(() => (this.loading = false));
     },

     noShowToken() {  

        this.getToken();

        const config = {
            headers: {
              "Accept": "application/json",
              "Authorization": "Bearer " + this.token,
            },
        };

        let url = "counter/noshow";        
        
        let formData = new FormData();
        formData.append("booking_id", this.token_details.booking_id);
        formData.append("token", this.token_details.token); 

        this.$axios
          .post(url, formData, config)
          .then((res) => {
            var responseData = res.data.message;
             this.fetchToken();
            console.log(responseData);
            this.$swal("", responseData, "success");
          })
        .catch((error) => {
          if (error.response) {
              if (error.response.data.message) {
                this.$swal("", error.response.data.message, "error");
               
              } else {
                this.$swal("", "Something went wrong", "error");
              }
          } else {
              this.$swal("", "Something went wrong", "error");
          }
        })
        .finally(() => (this.loading = false));
    },

    callNextToken() {  
      this.callingNextToken = true;
      let url = "counter/callNextToken";         
      this.getToken();
      this.$axios
      .get(url, { headers: { Authorization: "Bearer " + this.token } })
      .then((res) => {
            var responseData = res.data.message;
            console.log(responseData);
            this.$swal("", responseData, "success");
            this.fetchToken();
          })
          .catch((error) => {
            if (error.response) {
                if (error.response.data.message) {
                  this.$swal("", error.response.data.message, "error");
                } else {
                  this.$swal("", "Something went wrong", "error");
                }
            } else {
                this.$swal("", "Something went wrong", "error");
            }
          })
          .finally(() => {
            this.callingNextToken = false;
            this.loading = false;
          });

    },

    changeAvailability(status) {  
      let url = "counter/changeAvailability?status=" + status;         
      this.getToken();
      this.$axios
      .get(url, { headers: { Authorization: "Bearer " + this.token } })
      .then((res) => {
        var responseData = res.data.message;
        console.log(responseData);
        this.$swal("", responseData, "success");
        this.fetchToken();
      })
      .catch((error) => {
        if (error.response) {
            if (error.response.data.message) {
              this.$swal("", error.response.data.message, "error");
            } else {
              this.$swal("", "Something went wrong", "error");
            }
        } else {
            this.$swal("", "Something went wrong", "error");
        }
      })
      .finally(() => (this.loading = false));
    },


    logout() {

    let url = "counter/logout";         
    this.getToken();
    this.loading = true;
    this.$axios
    .get(url, { headers: { Authorization: "Bearer " + this.token } })
    .then((res) => {
      var responseData = res.data.data;
      console.log(responseData);
      
      if(localStorage.getItem('medicino_counter')) {
        localStorage.removeItem("medicino_counter");    
      }         
      this.$swal("", "You have been successfully logged out", "success");
      this.$router.push({ name: "login" });
                      
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.data.message) {
          if(typeof error.response.data.message === 'object') {
            console.log(error.response.status);
          } else {
            this.$swal("", error.response.data.message, "error");
          }                        
                      
        } else {
          this.$swal("", "Something went wrong", "error");
        }
      } else {
        this.$swal("", "Something went wrong", "error");
      }
    })
    .finally(() => (this.loading = false));


    },

    clearToken() {
      this.token_details.patient_name = "";
      this.token_details.booking_date = ""
      this.token_details.token = "";
      this.token_details.counter_id = "";
      this.token_details.updated_at = "";
    },
    
  },

  
};



</script>